import '../styles/Chart.css';

const Chart = () => {
    return; 
};

export default Chart; 